import React, { useEffect } from 'react'
import Navbar from './components/Navbar';
import Home from './components/Home';
import Experience from './components/Experience';
import Skills from './components/Skills';
import Projectss from './components/Projectss';
import Contact from './components/Contact';
import Aos from 'aos';
import "aos/dist/aos.css"

const App = () => {
  useEffect(()=>{
    Aos.init();

  })
  return (
    <>
     <Navbar />
     <div className='container'>
      <Home />
      <Experience />
      <Skills />
      <Projectss />
      <Contact />
      
     </div>
    </>
  );
};

export default App;
